import { Info } from 'lucide-react'

/**
 * Component to display information about Feather orders
 * This appears when a user selects a destination chain that uses the Feather flow
 */
const FeatherOrderNotice = ({ chainName }: { chainName: string }) => {
    return (
        <div className='mb-4 flex items-start gap-3 rounded-xl bg-blue-600/10 p-4'>
            <div className='shrink-0 pt-0.5'>
                <Info className='h-5 w-5 text-blue-500' />
            </div>
            <div className='space-y-1'>
                <h4 className='font-medium text-blue-500'>Feather Order</h4>
                <p className='text-sm text-gray-200'>
                    Exchanging to {chainName} uses our Feather system. Instead of a smart contract transaction, you'll
                    send funds directly to our deposit address. We'll handle the exchange and send {chainName}&nbsp; to
                    your destination wallet automatically.
                </p>
            </div>
        </div>
    )
}

export default FeatherOrderNotice
